import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class OddsEndsService {

    private subject = new Subject();

    constructor() { }

    /**
       * Sets data in the subject which is used within the components to process actions
       * @param data
       */
    setAction(data) {

        this.subject.next(data);

    }

    /**
     * Returns the Subject as an observable which is used within the components to process actions
     */
    getAction(): Observable<any> {

        return this.subject.asObservable();

    }
}
